import { createBrowserHistory, Location } from 'history';

import { getQueryParams } from '@rover/utilities/url';

const ROVER_URL_ROOT = 'https://www.rover.com';

const isGoogleCacheUrl = (location: Location, cacheParam: string | undefined): boolean =>
  location.pathname === '/search' && !!cacheParam && cacheParam.indexOf('cache') === 0;

const isCachedRoverUrl = (cacheParam: string): boolean => cacheParam.indexOf(ROVER_URL_ROOT) > -1;

const getPathnameFromQuery = (cacheParam: string): string => {
  if (typeof cacheParam === 'string') {
    const url = cacheParam.split(':').pop(); // i.e. `//www.rover.com/<pathname>/`
    const parser = document.createElement('a');
    parser.href = url || '';
    return parser.pathname;
  }
  return '';
};

/**
 * See DEV-37460; when loaded from google's cached-page server (webcache.googleusercontent.com),
 * SSR will mistake the '/search' in google's path name for the route it should render, which
 * causes all SSR pages to look like SSR Search.  To prevent this, detect google webcache, and
 * alter the path in the history object so the router will render the correct route.
 */
export default (): void => {
  const history = createBrowserHistory();
  const { location } = history;
  const { q } = getQueryParams();
  const cacheParam = Array.isArray(q) ? q[0] : q;

  if (isGoogleCacheUrl(location, cacheParam) && isCachedRoverUrl(cacheParam)) {
    history.replace(getPathnameFromQuery(cacheParam));
  }
};
